import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import { useUserStore } from "../../store/userStore";

function ThemeHandler() {
  const { accessToken } = useUserStore(
    useShallow((state) => ({
      accessToken: state.accessToken,
    }))
  );

  useEffect(() => {
    checkCurrentTheme();
  }, []);

  useEffect(() => {
    if (accessToken) {
      checkCurrentTheme();
    }
  }, [accessToken]);

  const checkCurrentTheme = async () => {
    const font = window.localStorage.getItem("font");
    const theme = window.localStorage.getItem("theme");

    if (theme && theme === "dark") {
      document.body.classList.remove("dark");
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }

    if (font && font === "lexend") {
      document.body.classList.remove("lexend");
      document.body.classList.remove("neue");
      document.body.classList.add("lexend");
    } else if (font && font === "comic-neue") {
      document.body.classList.remove("lexend");
      document.body.classList.remove("neue");
      document.body.classList.add("neue");
    } else {
      document.body.classList.remove("lexend");
      document.body.classList.remove("neue");
    }
  };

  return null;
}

export default ThemeHandler;
